function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactsSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.60156 9.00028C5.60156 12.5349 8.46692 15.4003 12.0016 15.4003C15.5362 15.4003 18.4016 12.5349 18.4016 9.00028C18.4016 5.46564 15.5362 2.60028 12.0016 2.60028C8.46692 2.60028 5.60156 5.46564 5.60156 9.00028ZM5.20078 16.4003C3.8753 16.4003 2.80078 17.4748 2.80078 18.8003C2.80078 20.1257 3.87529 21.2003 5.20078 21.2003H18.8008C20.1263 21.2003 21.2008 20.1257 21.2008 18.8003C21.2008 17.4748 20.1263 16.4003 18.8008 16.4003H5.20078Z",
    fill: "#147AFF",
    style: {
      fill: "#147AFF",
      fill: "color(display-p3 0.0784 0.4784 1.0000)",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactsSelected);
export default __webpack_public_path__ + "static/media/contacts-selected.a0d71065e294e493160a905ca65cc5bb.svg";
export { ForwardRef as ReactComponent };